// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button.btn-sticky-locale.v-btn.v-btn--contained.theme--light.v-size--default{position:fixed;right:1rem;bottom:5rem;border-radius:50px}button.btn-sticky.v-btn.v-btn--contained.theme--light.v-size--default{position:fixed;right:1rem;bottom:2rem;border-radius:50px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
